/* eslint-disable max-len */
import React from 'react'

export const TeamsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="27" viewBox="0 0 28 27" fill="none">
      <path
        d="M16.625 12.6653C16.625 12.2288 16.9788 11.875 17.4153 11.875H27.2097C27.6462 11.875 28 12.2288 28 12.6653V18.4375C28 21.5786 25.4536 24.125 22.3125 24.125V24.125C19.1714 24.125 16.625 21.5786 16.625 18.4375V12.6653Z"
        fill="url(#paint0_linear_6956_2032)"
      />
      <path
        d="M7.875 11.1976C7.875 10.6052 8.35521 10.125 8.94758 10.125H20.8024C21.3948 10.125 21.875 10.6052 21.875 11.1976V19.75C21.875 23.616 18.741 26.75 14.875 26.75V26.75C11.009 26.75 7.875 23.616 7.875 19.75V11.1976Z"
        fill="url(#paint1_linear_6956_2032)"
      />
      <circle cx="23.625" cy="7.5" r="2.625" fill="#34439E" />
      <circle cx="23.625" cy="7.5" r="2.625" fill="url(#paint2_linear_6956_2032)" />
      <circle cx="15.75" cy="5.75" r="3.5" fill="url(#paint3_linear_6956_2032)" />
      <mask id="mask0_6956_2032" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="7" y="0" width="15" height="27">
        <path
          d="M14.875 9.25C17.2913 9.25 19.25 7.29129 19.25 4.875C19.25 2.45871 17.2913 0.5 14.875 0.5C12.4587 0.5 10.5 2.45871 10.5 4.875C10.5 7.29129 12.4587 9.25 14.875 9.25Z"
          fill="url(#paint4_linear_6956_2032)"
        />
        <path
          d="M8.9476 10.125C8.35522 10.125 7.875 10.6052 7.875 11.1976V19.75C7.875 23.616 11.009 26.75 14.875 26.75C18.741 26.75 21.875 23.616 21.875 19.75V11.1976C21.875 10.6052 21.3948 10.125 20.8024 10.125H8.9476Z"
          fill="url(#paint5_linear_6956_2032)"
        />
      </mask>
      <g mask="url(#mask0_6956_2032)">
        <path
          d="M6.125 11.375C6.125 9.71815 7.46815 8.375 9.125 8.375H14.5C16.1569 8.375 17.5 9.71815 17.5 11.375V21.125C17.5 22.7819 16.1569 24.125 14.5 24.125H6.125V11.375Z"
          fill="black"
          fillOpacity="0.3"
        />
      </g>
      <rect y="6.625" width="15.75" height="15.75" rx="2" fill="url(#paint6_linear_6956_2032)" />
      <path d="M11.375 10.125H4.375V11.7304H6.99557V18.875H8.75443V11.7304H11.375V10.125Z" fill="white" />
      <defs>
        <linearGradient id="paint0_linear_6956_2032" x1="16.625" y1="12.5197" x2="28.1392" y2="20.0436" gradientUnits="userSpaceOnUse">
          <stop stopColor="#364088" />
          <stop offset="1" stopColor="#6E7EE1" />
        </linearGradient>
        <linearGradient id="paint1_linear_6956_2032" x1="7.875" y1="17.4784" x2="21.875" y2="17.4784" gradientUnits="userSpaceOnUse">
          <stop stopColor="#515FC4" />
          <stop offset="1" stopColor="#7084EA" />
        </linearGradient>
        <linearGradient id="paint2_linear_6956_2032" x1="21" y1="5.15132" x2="26.0718" y2="8.72035" gradientUnits="userSpaceOnUse">
          <stop stopColor="#364088" />
          <stop offset="1" stopColor="#6E7EE1" />
        </linearGradient>
        <linearGradient id="paint3_linear_6956_2032" x1="13.25" y1="3.25" x2="17.75" y2="8.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4858AE" />
          <stop offset="1" stopColor="#4E60CE" />
        </linearGradient>
        <linearGradient id="paint4_linear_6956_2032" x1="11.75" y1="1.75" x2="17.375" y2="8.3125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4858AE" />
          <stop offset="1" stopColor="#4E60CE" />
        </linearGradient>
        <linearGradient id="paint5_linear_6956_2032" x1="11.75" y1="1.75" x2="17.375" y2="8.3125" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4858AE" />
          <stop offset="1" stopColor="#4E60CE" />
        </linearGradient>
        <linearGradient id="paint6_linear_6956_2032" x1="-4.56347e-08" y1="14.5" x2="15.75" y2="14.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2A3887" />
          <stop offset="1" stopColor="#4C56B9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
